import { render, staticRenderFns } from "./ApprovalQueue.vue?vue&type=template&id=281d7582"
import script from "./ApprovalQueue.vue?vue&type=script&lang=js"
export * from "./ApprovalQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports